import { useInfiniteQuery } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from "../../Context/AuthContext";

const fetchAdminMessages = async ({ pageParam = 1 }, token, user) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/messages/get-messages/${user.userId}?page=${pageParam}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Error fetching Admin messages');
  }

  return response.json();
};

const useAdminMessages = () => {
  const { token, user } = useContext(AuthContext);
  return useInfiniteQuery(
    ['adminMessages', user.userId], 
    ({ pageParam }) => fetchAdminMessages({ pageParam }, token, user),
    {
      getNextPageParam: (lastPage) => {
        const nextPage = lastPage.currentPage + 1;
        return nextPage <= Math.ceil(lastPage.totalMessages / 10) ? nextPage : undefined;
      },
    }
  );
};

export default useAdminMessages;

